import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
}                                from '@angular/core';
import {ApDynComponentComponent} from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  PpLogfileEditWizardProvider
}                                from './logfile-edit-wizard/config/pp-logfile-edit-wizard.provider';
import {ObjectFactory}           from 'ts-tooling';
import {FormStore}               from '../../stores/layout/form.store';
import {ILogFileEditWizard}      from './logfile-edit-wizard/pp-logfile-edit-wizard.types';
import {
  PlantProtectionPlanBookStore
}                                from '../../stores/plant-protection/plant-protection-planbook.store';
import IPlantProtectionLogEdit = Data.PlantProtection.IPlantProtectionLogEdit;
import IPlantProtectionLogEditProduct = Data.PlantProtection.IPlantProtectionLogEditProduct;

@Component({
  selector: 'pp-plan-edit',
  template: `
    <ap-dyncomponent [caption]="'Global__Show'"
                     [loading$]="provider.loading$"
                     [headerIcon]="'ap-fungidetect-icon'"
                     [fieldSets]="provider.fieldSets"
                     [pager]="provider.pager">
      <div class="ap-form-actions" dynforms.action>
        <div apResponsive
             [sizeMd]="'50-100'"
             [style.text-align]="'left'">
          <button kendoButton
                  [id]="'button_prev'"
                  [type]="'button'"
                  [class]="'k-button k-primary button-important'"
                  (click)="close()">
            <ap-responsive-text [key]="'Global_Back_With_Arrow'"></ap-responsive-text>
          </button>
        </div>
        <div apResponsive
             [sizeMd]="'50-100'"
             [style.text-align]="'right'">
          <button kendoButton
                  [id]="'button_next'"
                  [type]="'button'"
                  [class]="'k-button k-primary button-important'"
                  [disabled]="(provider.productList$ | async).length === 0"
                  (click)="save()">
            <ap-responsive-text [key]="'Global__Save'"></ap-responsive-text>
          </button>
        </div>
      </div>
    </ap-dyncomponent>
    <ng-template #plantProtectionProductListTemplate>
      <ap-dyngrids [class]="'ap-dynform-grid-item'"
                   [class.error]="(provider.productList$ | async).length === 0"
                   [id]="'SelectedProducts'"
                   [columns]="provider.productColumns"
                   [items]="provider.productList$ | async"
                   [pageable]="false"
                   [groupable]="false"
                   [hideHeader]="true"
                   [checkboxDisabled]="true"
                   [selectable]="{checkboxOnly: false, mode: 'single'}">
      </ap-dyngrids>
    </ng-template>
  `,
  styles: []
})
export class PpLogfileEditComponent implements OnInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  @ViewChild('plantProtectionProductListTemplate', {static: true}) public plantProtectionProductListTemplate: TemplateRef<any>;

  constructor(public provider: PpLogfileEditWizardProvider,
              private planProtectionStore: PlantProtectionPlanBookStore,
              private formStore: FormStore) {
  }

  ngOnInit(): void {
    this.provider.data = ObjectFactory.Copy(this.formStore.Listen(s => s.updateComponent).getValue().data.SourceItem);
    this.provider.dynForm = this.dynComponent.dynForm;
    this.provider.onInit(this.plantProtectionProductListTemplate);
  }

  ngOnDestroy(): void {
    this.provider.onDestroy();
  }

  public close(): void {
    this.formStore.closeForm();
  }

  public save(): void {
    const values: ILogFileEditWizard = this.dynComponent.dynForm.form.value;
    this.provider.data.WorkingWidth = values.WorkingWidth;
    const logEdit: IPlantProtectionLogEdit = {
      DatasetFieldMapId: this.provider.data.Id,
      PlanId: values.Plan,
      WorkingWidth: values.WorkingWidth,
      Products: this.provider.productList$.getValue().map((item): IPlantProtectionLogEditProduct => ({
        ProductId: item.ProductItem?.Id,
        Rate: item.ApplRate,
        Unit: item.Unit
      })),
      DriverId: values.Driver,
      MachineId: values.Machine,
      InstrumentId: values.Instrument
    };
    this.planProtectionStore.setPlanningToLogfile(logEdit);
    this.formStore.closeForm();
  }
}
